const parseDateValue = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

const BETA_FREE_MODE = process.env.REACT_APP_BETA_FREE_MODE === 'true';

export const isPremiumPlan = (plan) => ['premium', 'pro'].includes(plan);

export const isSubscriptionActive = (subscription) => {
  if (!subscription) return false;

  const status = subscription.status || 'active';
  if (status === 'active') {
    const endDate = parseDateValue(subscription.endDate);
    if (endDate && endDate.getTime() <= Date.now()) {
      return false;
    }
    return true;
  }

  if (status === 'cancelled') {
    const endDate = parseDateValue(subscription.endDate);
    if (!endDate) return false;
    return endDate.getTime() > Date.now();
  }

  return false;
};

export const hasPremiumAccess = (user) => {
  if (BETA_FREE_MODE) {
    return Boolean(user);
  }

  const subscription = user?.subscription;
  if (!subscription) return Boolean(user?.isPremium);
  if (!isPremiumPlan(subscription.plan)) return false;
  return isSubscriptionActive(subscription);
};
